import TablePage from '../../../../../components/table_page';
import Form from './form/index';

export default {
  name: 'table-component',
  extends: TablePage,
  components: { Form },
  data() {
    return {};
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.formName = 'Form';
        this.modalConfig.title = '详情';
        this.openFull();
        this.formConfig = {
          code: val.code,
          row,
        };
      }
    },
  },
  created() {
    this.getConfigList('big_meeting_report');
  },

};
